module.exports = __webpack_public_path__ + "img/cards.18948839.png";